export default __webpack_public_path__ + "static/media/locationIcon.cde8e5a7.svg";